import React, { useState } from 'react';
import { 
    SparklesIcon, 
    ShieldCheckIcon,
    SunIcon,
    BeakerIcon,
    InformationCircleIcon,
    ChevronDownIcon,
    ChevronUpIcon,
    ExclamationTriangleIcon
} from '@heroicons/react/24/outline';

function CareGuidePage() {
    const [expandedSection, setExpandedSection] = useState('genel-bakim');

    const careGuides = {
        'genel-bakim': {
            title: 'Genel Bakım Kuralları',
            icon: SparklesIcon,
            color: 'from-blue-500 to-blue-600',
            content: [
                {
                    title: 'Yıkama Öncesi Hazırlık',
                    tips: [
                        'Kıyafetlerin etiketlerini mutlaka okuyun',
                        'Renkleri ayırın (koyu, açık, beyaz)',
                        'Cepleri kontrol edin ve boşaltın',
                        'Lekelenmiş alanları önceden işlem görün',
                        'Fermuarları kapatın, düğmeleri açın'
                    ]
                },
                {
                    title: 'Yıkama Sıcaklığı',
                    tips: [
                        'Pamuklu kumaşlar: 30-40°C',
                        'Sentetik kumaşlar: 30°C',
                        'Yün ve ipek: 20-30°C (hassas program)',
                        'Beyaz çamaşırlar: 60°C (gerektiğinde)',
                        'Renkli kumaşlar: 30-40°C'
                    ]
                },
                {
                    title: 'Deterjan Seçimi',
                    tips: [
                        'Çocuk cildine uygun, hipoalerjenik deterjan kullanın',
                        'Yumuşatıcı miktarını aşmayın',
                        'Ağartıcı kullanımında dikkatli olun',
                        'Doğal deterjanları tercih edin',
                        'Fazla köpük oluşturmayın'
                    ]
                }
            ]
        },
        'kumas-turleri': {
            title: 'Kumaş Türlerine Göre Bakım',
            icon: ShieldCheckIcon,
            color: 'from-green-500 to-green-600',
            content: [
                {
                    title: 'Pamuklu Kumaşlar',
                    tips: [
                        '30-40°C\'de yıkayın',
                        'Ters çevirerek yıkayın',
                        'Orta devirde sıkın',
                        'Gölgede kurutun',
                        'Nemli iken ütüleyin'
                    ]
                },
                {
                    title: 'Sentetik Kumaşlar (Polyester, Naylon)',
                    tips: [
                        '30°C\'de hassas programda yıkayın',
                        'Düşük devirde sıkın',
                        'Hızlı kurur, fazla ısı vermeyin',
                        'Düşük ısıda ütüleyin',
                        'Statik elektriği önlemek için yumuşatıcı kullanın'
                    ]
                },
                {
                    title: 'Yün Kumaşlar',
                    tips: [
                        'Özel yün deterjanı kullanın',
                        '20-30°C soğuk suda yıkayın',
                        'Asla sıkmayın, hafifçe sıkıştırın',
                        'Düz yüzeyde kurutun',
                        'Buhar ütüsü kullanın'
                    ]
                },
                {
                    title: 'Denim (Kot) Kumaşlar',
                    tips: [
                        'İlk yıkamalarda tek başına yıkayın',
                        'Ters çevirerek yıkayın',
                        '30°C\'de yıkayın',
                        'Doğal kurutmayı tercih edin',
                        'Renk koruyucu deterjan kullanın'
                    ]
                }
            ]
        },
        'kurutma': {
            title: 'Kurutma ve Ütüleme',
            icon: SunIcon,
            color: 'from-yellow-500 to-orange-500',
            content: [
                {
                    title: 'Doğal Kurutma',
                    tips: [
                        'Gölgeli ve havadar yerleri tercih edin',
                        'Direkt güneş ışığından kaçının',
                        'Kıyafetleri düzgün asın',
                        'Rüzgarlı günlerde daha hızlı kurur',
                        'Yün ürünleri düz yüzeyde kurutun'
                    ]
                },
                {
                    title: 'Makine Kurutma',
                    tips: [
                        'Düşük ısı ayarını kullanın',
                        'Aşırı kurutmayın',
                        'Kurutma topları kullanın',
                        'Hassas kumaşları makineye atmayın',
                        'Yarı kuru çıkarıp asın'
                    ]
                },
                {
                    title: 'Ütüleme İpuçları',
                    tips: [
                        'Kumaş türüne uygun sıcaklık ayarı',
                        'Nemli iken ütüleyin',
                        'Ters taraftan ütüleyin',
                        'Buhar özelliğini kullanın',
                        'Baskılı alanları koruyun'
                    ]
                }
            ]
        },
        'leke-temizligi': {
            title: 'Leke Temizliği',
            icon: BeakerIcon,
            color: 'from-purple-500 to-purple-600',
            content: [
                {
                    title: 'Yaygın Lekeler ve Çözümleri',
                    tips: [
                        'Kan lekesi: Soğuk su ve tuz',
                        'Yağ lekesi: Bulaşık deterjanı',
                        'Meyve suyu: Sirke ve su karışımı',
                        'Çikolata: Soğuk su ve deterjan',
                        'Çim lekesi: Alkol ve deterjan'
                    ]
                },
                {
                    title: 'Leke Temizliği Kuralları',
                    tips: [
                        'Lekeyi hemen müdahale edin',
                        'Dıştan içe doğru temizleyin',
                        'Ovmayın, hafifçe bastırın',
                        'Soğuk su kullanın (kan, protein lekeleri için)',
                        'Test edin önce görünmeyen alanda'
                    ]
                },
                {
                    title: 'Doğal Leke Çıkarıcılar',
                    tips: [
                        'Beyaz sirke: Kireç ve ter lekeleri',
                        'Limon suyu: Sararmış beyazlar',
                        'Karbonat: Koku ve leke giderici',
                        'Tuz: Taze kan lekeleri',
                        'Süt: Mürekkep lekeleri'
                    ]
                }
            ]
        }
    };

    const fabricSymbols = [
        { symbol: '🌡️', meaning: 'Yıkama sıcaklığı', description: 'Sayı derecesini gösterir' },
        { symbol: '🚫', meaning: 'Yıkama yasak', description: 'Kuru temizleme gerekli' },
        { symbol: '🔺', meaning: 'Ağartma', description: 'Üçgen ağartma sembolü' },
        { symbol: '⭕', meaning: 'Kurutma', description: 'Daire kurutma makinesi' },
        { symbol: '🔥', meaning: 'Ütüleme', description: 'Nokta sayısı ısı seviyesi' },
        { symbol: '💧', meaning: 'Kuru temizleme', description: 'Profesyonel temizlik' }
    ];

    const toggleSection = (section) => {
        setExpandedSection(expandedSection === section ? null : section);
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
            {/* Hero Section */}
            <div className="bg-gradient-to-r from-brand-green to-brand-green-light text-white py-12 sm:py-16">
                <div className="container mx-auto px-4 text-center">
                    <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 flex items-center justify-center">
                        <SparklesIcon className="w-8 h-8 sm:w-10 sm:h-10 mr-3" />
                        Bakım Rehberi
                    </h1>
                    <p className="text-lg sm:text-xl opacity-90 max-w-2xl mx-auto">
                        Çocuğunuzun kıyafetlerinin uzun süre yeni kalması için 
                        doğru bakım yöntemlerini öğrenin
                    </p>
                </div>
            </div>

            <div className="container mx-auto px-4 py-12">
                
                {/* Hızlı İpuçları */}
                <div className="mb-8">
                    <div className="bg-white rounded-2xl shadow-xl p-6 border border-gray-100">
                        <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
                            <InformationCircleIcon className="w-6 h-6 text-brand-green mr-2" />
                            Hızlı İpuçları
                        </h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                            <div className="p-4 bg-blue-50 rounded-lg border border-blue-200">
                                <h3 className="font-bold text-blue-800 mb-2">💡 Etiket Okuyun</h3>
                                <p className="text-sm text-blue-700">Her kıyafetin bakım etiketi farklıdır. Mutlaka kontrol edin.</p>
                            </div>
                            <div className="p-4 bg-green-50 rounded-lg border border-green-200">
                                <h3 className="font-bold text-green-800 mb-2">🌡️ Sıcaklık Önemli</h3>
                                <p className="text-sm text-green-700">Yüksek sıcaklık kumaşa zarar verebilir. Düşük sıcaklık tercih edin.</p>
                            </div>
                            <div className="p-4 bg-yellow-50 rounded-lg border border-yellow-200">
                                <h3 className="font-bold text-yellow-800 mb-2">⚡ Hızlı Müdahale</h3>
                                <p className="text-sm text-yellow-700">Lekelere hemen müdahale edin. Bekletmek temizliği zorlaştırır.</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bakım Rehberi Bölümleri */}
                <div className="space-y-6">
                    {Object.entries(careGuides).map(([key, guide]) => {
                        const IconComponent = guide.icon;
                        const isExpanded = expandedSection === key;
                        
                        return (
                            <div key={key} className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
                                <button
                                    onClick={() => toggleSection(key)}
                                    className={`w-full px-6 py-4 bg-gradient-to-r ${guide.color} text-white font-bold text-lg flex items-center justify-between hover:opacity-90 transition-all`}
                                >
                                    <span className="flex items-center">
                                        <IconComponent className="w-6 h-6 mr-3" />
                                        {guide.title}
                                    </span>
                                    {isExpanded ? 
                                        <ChevronUpIcon className="w-5 h-5" /> : 
                                        <ChevronDownIcon className="w-5 h-5" />
                                    }
                                </button>
                                
                                {isExpanded && (
                                    <div className="p-6">
                                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
                                            {guide.content.map((section, index) => (
                                                <div key={index} className="bg-gray-50 rounded-lg p-4">
                                                    <h3 className="font-bold text-gray-800 mb-3 text-lg">
                                                        {section.title}
                                                    </h3>
                                                    <ul className="space-y-2">
                                                        {section.tips.map((tip, tipIndex) => (
                                                            <li key={tipIndex} className="flex items-start text-sm text-gray-700">
                                                                <span className="text-brand-green mr-2 mt-1">•</span>
                                                                <span>{tip}</span>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>

                {/* Kumaş Sembolleri */}
                <div className="mt-8">
                    <div className="bg-white rounded-2xl shadow-xl p-6 border border-gray-100">
                        <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
                            <InformationCircleIcon className="w-6 h-6 text-brand-green mr-2" />
                            Bakım Etiket Sembolleri
                        </h2>
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                            {fabricSymbols.map((item, index) => (
                                <div key={index} className="flex items-center p-4 bg-gray-50 rounded-lg">
                                    <span className="text-2xl mr-4">{item.symbol}</span>
                                    <div>
                                        <h3 className="font-bold text-gray-800">{item.meaning}</h3>
                                        <p className="text-sm text-gray-600">{item.description}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Uyarılar */}
                <div className="mt-8">
                    <div className="bg-white rounded-2xl shadow-xl p-6 border border-gray-100">
                        <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
                            <ExclamationTriangleIcon className="w-6 h-6 text-red-500 mr-2" />
                            Önemli Uyarılar
                        </h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
                                <h3 className="font-bold text-red-800 mb-3">❌ Yapmamanız Gerekenler</h3>
                                <ul className="space-y-2 text-sm text-red-700">
                                    <li>• Sıcak su ile protein bazlı lekeleri yıkamayın</li>
                                    <li>• Yün ürünleri makine kurutmayın</li>
                                    <li>• Ağartıcıyı renkli kumaşlarda kullanmayın</li>
                                    <li>• Lekeyi ovarak temizlemeye çalışmayın</li>
                                    <li>• Etiket okumadan yıkamayın</li>
                                </ul>
                            </div>
                            <div className="p-4 bg-green-50 border border-green-200 rounded-lg">
                                <h3 className="font-bold text-green-800 mb-3">✅ Mutlaka Yapın</h3>
                                <ul className="space-y-2 text-sm text-green-700">
                                    <li>• Renkleri ayırarak yıkayın</li>
                                    <li>• Çocuk cildine uygun deterjan kullanın</li>
                                    <li>• Kıyafetleri ters çevirerek yıkayın</li>
                                    <li>• Lekelere hemen müdahale edin</li>
                                    <li>• Düzenli bakım yapın</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Yardım */}
                <div className="mt-8">
                    <div className="bg-white rounded-2xl shadow-xl p-6 border border-gray-100 text-center">
                        <h3 className="text-xl font-bold text-gray-800 mb-4">
                            Daha Fazla Yardıma İhtiyacınız mı Var?
                        </h3>
                        <p className="text-gray-600 mb-6">
                            Ürün bakımı konusunda sorularınız varsa, 
                            müşteri hizmetlerimizden destek alabilirsiniz.
                        </p>
                        <div className="flex flex-col sm:flex-row gap-4 justify-center">
                            <a 
                                href="/iletisim" 
                                className="bg-brand-green text-white px-6 py-3 rounded-lg hover:bg-brand-green-light transition-colors"
                            >
                                Bize Ulaşın
                            </a>
                            <a 
                                href="/sss" 
                                className="border-2 border-brand-green text-brand-green px-6 py-3 rounded-lg hover:bg-brand-green hover:text-white transition-colors"
                            >
                                SSS Sayfası
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CareGuidePage;